module.exports = getExpiredBatchIds

// Given a list of batch ids, returns the ones that resolve to a master-data
// batch doc whose expiry has passed. Batch ids that don't resolve to any doc
// (new/unknown batch) are left out - mirrors the `!batch.expiry ||
// batch.expiry > date` semantics used in order/api/write/accept-orders.js.
//
// This is a plain check, not a validator: it returns data and leaves it up
// to the caller to decide what (if anything) to do about expired batches.
async function getExpiredBatchIds (state, batchIds, date = new Date().toJSON()) {
  if (!batchIds || !batchIds.length) return []

  const { rows } = await state.masterDataDB.allDocs({ keys: batchIds, include_docs: true })

  return rows
    .filter(row => row.doc && row.doc.expiry && row.doc.expiry <= date)
    .map(row => row.id)
}
